import React from 'react';
import { Link } from 'react-router-dom';

function ArticleItem(props) {
    return (
        <>
            <li class="cards_item">
                <div class="card">
                    <div class="card_image"><img src={props.image_src} /></div>
                    <div class="card_content">
                        <h2 class="card_title">{props.title}</h2>
                        <p class="card_text">{props.tags}</p>
                        <div className="link_button">
                            <a class="btn card_btn" target="_blank" href={props.link}>Read</a>
                        </div>
                    </div>
                </div>
            </li>

        </>
    )
}

export default ArticleItem